import GraphBookedDays from './GraphBookedDays'
import GraphEmployeeBookingsWeek from './GraphEmployeeBookingsWeek'
import GraphCheckinTime from './GraphCheckinTime'
import GraphTotalBookingsWeek from './GraphTotalBookingsWeek'
import GraphBookingPresenceChart from './GraphBookingPresenceChart'
import GraphBookingPresenceWeekChart from './GraphBookingPresenceWeekChart'
import GraphBookingPresenceDayChart from './GraphBookingPresenceDayChart'

import GraphBookingDays from './GraphBookingDays'
import GraphBookTime from './GraphBookTime'

const GraphVariables = ({ dateRange, building, floor, room, team, employee }) => {
	return (
		{
			date: dateRange,
			buildingGuid: building,
			floorGuid: floor,
			roomGuid: room,
			teamGuid: team,
			employeeGuid: employee,
		}
	);
}

export {
	GraphBookedDays,
	GraphEmployeeBookingsWeek,
	GraphCheckinTime,
	GraphTotalBookingsWeek,
	GraphBookingPresenceChart,
	GraphBookingPresenceWeekChart,
	GraphBookingPresenceDayChart,
	
	GraphBookingDays,
	GraphBookTime,
	
	GraphVariables
}
